import { useAuth } from '@/hooks/use-auth';
import { useSidebar } from '@/hooks/use-sidebar';
import { Button } from '@/components/ui/button';
import { Link } from 'wouter';
import { LogOut } from 'lucide-react';
import { ThemeToggle } from './theme-toggle';
import { NotificationCenter } from '@/components/notifications/NotificationCenter';

export default function MainHeader() {
  const { user, logoutMutation } = useAuth();
  const { collapsed } = useSidebar();

  return (
    <header className="main-header bg-white/90 dark:bg-slate-900/90 backdrop-blur-sm border-b border-slate-200/80 dark:border-slate-800/80 shadow-soft">
      <div className="w-full px-4 py-2 flex justify-end items-center">
        <div className="flex items-center gap-2 sm:gap-3">
          <ThemeToggle />

          {user && <NotificationCenter />}

          {user && (
            <>
              <div className="hidden sm:flex items-center gap-2 bg-slate-100/70 dark:bg-slate-800/70 px-3 sm:px-4 py-2 rounded-lg shadow-button">
                <div className="h-7 w-7 rounded-lg bg-slate-500 dark:bg-slate-600 flex items-center justify-center text-white text-xs font-bold shadow-sm">
                  {user.username.charAt(0).toUpperCase()}
                </div>
                <span className="text-sm text-slate-800 dark:text-slate-200 font-medium max-w-[120px] md:max-w-[200px] truncate">
                  {user.username}
                </span>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  try {
                    logoutMutation.mutate();
                    console.log('Desktop header: Logout mutation triggered');
                  } catch (error) {
                    console.error('Desktop header: Error triggering logout:', error);
                  }
                }}
                disabled={logoutMutation.isPending}
                className="text-sm rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-600 dark:hover:text-red-400 hover:border-red-200 dark:hover:border-red-800 transition-all shadow-button"
              >
                {logoutMutation.isPending ? (
                  <>
                    <svg
                      className="animate-spin mr-2 h-3.5 w-3.5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <span className="hidden sm:inline">Logging out...</span>
                  </>
                ) : (
                  <>
                    <LogOut className="h-3.5 w-3.5 sm:mr-2" />
                    <span className="hidden sm:inline">Logout</span>
                  </>
                )}
              </Button>
            </>
          )}
          {!user && (
            <Button
              asChild
              size="sm"
              className="rounded-lg bg-slate-800 hover:bg-slate-700 dark:bg-slate-700 dark:hover:bg-slate-600 transition-all hover:shadow-md shadow-button"
            >
              <Link href="/auth">Login</Link>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
